import { MethodsTypes, IRequestConfig } from 'models/Axios';
import axios from 'axios';
import Services from './index.service';

export default class ScoreBarSevice extends Services<any, any> {
  /**
   * Function to get a limited qtd of items
   * @param currentPage Range to skip, you need only pass currentPage (ex: currentPage = 1)
   * @param pageSize Range to take, you need only pass pageSize (ex: pageSize = 15)
   */
  public async GetScore() {
    const endpoint = `${this.base_url}/`;
    const config: IRequestConfig<any> = {
      url: `${endpoint}ratings/average`,
      method: MethodsTypes.get,
      headers: {
        Authorization: `Bearer ${this.access_token()}`,
      },
    };

    return await axios(config)
      .then((result) => result.data)
      .catch(() => {});
  }
}
